import React, { useState, useMemo } from 'react';
import Checkbox from 'components/elements/atoms/Checkbox';

export default function StudentList({
  loading,
  students,
  selectedStudents,
  onChange,
}) {
  const [showAll, setShowAll] = useState(false);

  const totalCount = students.length;

  const displayedStudents = useMemo(() => {
    if (showAll) return students.slice(0, 100);
    return students.slice(0, 5);
  }, [students, showAll]);

  const allSelected = selectedStudents.length === students.length;

  const toggleIndividual = (student) => {
    const exists = selectedStudents.some((s) => s.email === student.email);
    if (exists) {
      onChange(selectedStudents.filter((s) => s.email !== student.email));
    } else {
      onChange([...selectedStudents, student]);
    }
  };

  const toggleAll = () => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(students);
    }
  };

  if (loading)
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '16px' }}
      />
    );

  return (
    <div>
      {/* ALL STUDENTS OPTION */}
      {totalCount > 5 && (
        <Checkbox
          className="mb-3 d-block"
          checked={allSelected}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleAll();
          }}
        >
          All {totalCount} students
        </Checkbox>
      )}

      {/* INDIVIDUAL STUDENTS */}
      {displayedStudents.map((student) => (
        <Checkbox
          className="mb-2 d-block"
          key={student.email}
          checked={selectedStudents.some((t) => t.email === student.email)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleIndividual(student);
          }}
        >
          {student.name} ({student.email})
        </Checkbox>
      ))}

      {/* SHOW ALL LINK */}
      {totalCount > 5 && !showAll && (
        <div
          className="mt-2 av-blue pointer"
          style={{ cursor: 'pointer', fontSize: '14px' }}
          onClick={() => setShowAll(true)}
        >
          Show all students
        </div>
      )}

      {/* LIMIT NOTE */}
      {showAll && totalCount > 100 && (
        <div className="mt-2" style={{ fontSize: '13px', color: '#888' }}>
          Showing first 100 of {totalCount} students
        </div>
      )}
    </div>
  );
}
